import { useTranslation } from 'react-i18next'

import { Text, VStack } from '@enechain/ecloud-designsystem'

import type { BidCsvDateCount } from '~/models/bidCsvDateCount'

type Props = {
  /** 受渡日ごとの取込対象件数 (`toBidCsvDateCounts` の戻り値)。 */
  dateCounts: BidCsvDateCount[]
}

/**
 * 入札 CSV 取込 Step2 の「受渡日ごとの取込対象」 (スポット通常入札 AC-SPOT-014 /
 * 時間前入札 AC-BCI-002)。 1 ファイルに複数の受渡日を入れられる CSV で、 どの受渡日に
 * 何件入るかを確定前に見せる。 design に件数の置き場が無いので、 呼び出し側が件数
 * サマリの直下に並べる。 取込対象が 1 件も無い (空配列) 時は見出しごと出さない。
 */
export const BidCsvDateCounts = ({
  dateCounts,
}: Props): React.ReactElement | null => {
  const { t } = useTranslation()
  if (dateCounts.length === 0) return null
  return (
    <VStack align="stretch" gap={1}>
      <Text textStyle="label">
        {t('page:biddingCommon.csvDateCounts.title')}
      </Text>
      {dateCounts.map((c) => (
        <Text key={c.date}>
          {t('page:biddingCommon.csvDateCounts.item', {
            date: c.date,
            count: c.count,
          })}
        </Text>
      ))}
    </VStack>
  )
}
